
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


const state = {
    bodyOverlay: false,
    windowWidth: null,

    validatePaymentModal: false,
    cancelOrderModal: null,
    shipmentModal: null,
    updateShipmentModal: null,
    trackingNumberDrawer: null,
    
    textEditor: null,
    textEditorDrawer: null,

    // segment
    segmentPersonnelModel: null,
    applySegmentPersonnelModel: null,

    // 
    activeDesktopMenu: false,
    hasSearch: false,
    popMenu: false,
    popShare: false,
    homeAboutPopVideo: false,

    sidebarCollapse: getCookie('sidebarCollapsed') === '1' ? true : false,
}

export default state